import { z } from 'zod';

/** Single visibility condition (no arbitrary eval) */
export const SurveyVisibilityConditionSchema = z.object({
    questionId: z.string(),
    op: z.enum(['equals', 'notEquals', 'in', 'notIn', 'isEmpty', 'isNotEmpty']),
    value: z.unknown().optional(),
});

export const SurveyVisibilityRuleSchema = z.object({
    all: z.array(SurveyVisibilityConditionSchema).optional(),
    any: z.array(SurveyVisibilityConditionSchema).optional(),
});

const LocalizedStringSchema = z.union([
    z.string(),
    z.record(z.string(), z.string()),
]);

export const SurveyOptionSchema = z.union([
    z.string(),
    z.object({
        label: LocalizedStringSchema,
        points: z.number().optional(),
        value: z.string().optional(),
    }),
]);

export const SurveyQuestionV2Schema = z.object({
    id: z.string(),
    order: z.number().int().optional(),
    type: z.enum([
        'section',
        'pageBreak',
        'shortText',
        'paragraph',
        'multipleChoice',
        'checkboxes',
        'dropdown',
        'file',
        'rating',
        'nps',
        'matrix',
    ]),
    title: LocalizedStringSchema.optional(),
    description: LocalizedStringSchema.optional(),
    required: z.boolean().optional(),
    options: z.array(SurveyOptionSchema).optional(),
    minSelected: z.number().optional(),
    maxSelected: z.number().optional(),
    matrixRows: z.array(z.string()).optional(),
    matrixColumns: z.array(z.string()).optional(),
    matrixCellType: z.enum(['radio', 'rating']).optional(),
    ratingMin: z.number().optional(),
    ratingMax: z.number().optional(),
    npsShowFollowUp: z.boolean().optional(),
    fileMaxCount: z.number().int().min(1).max(20).optional(),
    fileAccept: z.string().optional(),
    visibilityRule: SurveyVisibilityRuleSchema.optional(),
});

export const SurveyDefinitionV2Schema = z.object({
    version: z.literal(2),
    scoringEnabled: z.boolean().default(false),
    showScoresWhileFilling: z.boolean().default(false),
    questionsFromPool: z.number().int().min(1).nullable().optional(),
    randomizeQuestions: z.boolean().default(false),
    randomizeAnswers: z.boolean().default(false),
    questions: z.array(SurveyQuestionV2Schema),
});

export const SurveyDefinitionSchema = z.union([SurveyDefinitionV2Schema, z.record(z.string(), z.unknown())]);
